import React from 'react'
import Navbar from './Components/Navbar/Navbar'
import './App.css'
import Banner from './Components/Banner/Banner'
import Rowpost from './Components/Rowpost/Rowpost'
import { action,actionmovies,comedy,Documentries,horror,originals, romcom } from './urls'



function App() {
  return (
    <div className='App'>
      <Navbar/>
      <Banner/>
      <Rowpost url={originals} title='Netflix Originals'/>
      <Rowpost  url={action} title='Action' isSmall />
      <Rowpost  url={comedy} title='Comedy Movies' isSmall />
      <Rowpost  url={horror} title='Horror Movies' isSmall />
      <Rowpost  url={romcom} title='Romance Movies' isSmall />
      <Rowpost  url={actionmovies} title='Action Movies' isSmall />
      <Rowpost  url={Documentries} title='Documentries' isSmall />
      
    </div>
  )
}

export default App
